import React from "react";

export default function Bottom() {
  return (
    <div id="for-link">
      <a
        className="githubLink"
        rel="noreferrer"
        href="https://github.com/sparrow2100/weather-app-final-project"
        target="_blank"
      >
        Open Source
      </a>
    </div>
  );
}
